module.exports = __webpack_public_path__ + "img/logo-emls.4dd70846.png";